import CryptoJS from "crypto-js";
/* 密钥 */
// const KEY = "kjlhkjl";
// const IV = "kjlhkjl";
const KEY = CryptoJS.enc.Hex.parse("kjlhkjl_kjlhkjl_kjlhkjl_kjlhkjl_");
const IV = CryptoJS.enc.Hex.parse("kjlhkjl_kjlhkjl_kjlhkjl_kjlhkjl_");
const CRYPTOS = {
  iv: IV,
  mode: CryptoJS.mode.CBC,
  padding: CryptoJS.pad.Pkcs7
};
/* 加密 */
export const encrypt = (params) => {
  try {
    return CryptoJS.AES.encrypt(
      JSON.stringify(params),
      KEY,
      CRYPTOS
    ).toString();
  } catch (_) {
    return "";
  }
};
/* 解密 */
export const decrypt = (text) => {
  try {
    const bytes = CryptoJS.AES.decrypt(text, KEY, CRYPTOS);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    return "";
  }
};
